(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-careers-section]');
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('#CareersApplication');
    if (!form || form.querySelector('[data-success-panel]')) return;
    const area = form.querySelector('[data-area-select]');
    const otherGroup = form.querySelector('[data-other-area]');
    const otherInput = otherGroup.querySelector('input');
    const deliveryGroup = form.querySelector('[data-delivery-question]');
    const deliverySelect = deliveryGroup.querySelector('select');
    const firstName = form.querySelector('[data-first-name]');
    const lastName = form.querySelector('[data-last-name]');
    const subject = form.querySelector('[data-application-subject]');
    const submissionDate = form.querySelector('[data-submission-date]');
    const errorSummary = form.querySelector('[data-error-summary]');
    const errorList = form.querySelector('[data-error-list]');
    const submit = form.querySelector('[data-submit]');
    const status = form.querySelector('[data-submit-status]');

    const updateConditionalFields = () => {
      const isOther = area.value === 'Other';
      const isDelivery = area.value === 'Delivery';
      otherGroup.hidden = !isOther;
      otherInput.disabled = !isOther;
      otherInput.required = isOther;
      deliveryGroup.hidden = !isDelivery;
      deliverySelect.disabled = !isDelivery;
      deliverySelect.required = isDelivery;
    };

    const updateSubject = () => {
      const name = `${firstName.value.trim()} ${lastName.value.trim()}`.trim();
      if (!name || !area.value) {
        subject.value = section.dataset.subjectPrefix;
        return;
      }
      subject.value = `${section.dataset.subjectPrefix}: ${name} | ${area.value}`;
    };

    area.addEventListener('change', () => {
      updateConditionalFields();
      updateSubject();
    });
    firstName.addEventListener('input', updateSubject);
    lastName.addEventListener('input', updateSubject);
    updateConditionalFields();
    updateSubject();
    submissionDate.value = new Date().toISOString();

    form.addEventListener('input', (event) => event.target.removeAttribute('aria-invalid'));
    form.addEventListener('submit', (event) => {
      const invalidFields = Array.from(form.querySelectorAll(':invalid')).filter((field) => !field.disabled);
      if (invalidFields.length) {
        event.preventDefault();
        errorList.innerHTML = '';
        invalidFields.forEach((field) => {
          field.setAttribute('aria-invalid', 'true');
          const label = form.querySelector(`label[for="${field.id}"]`);
          const item = document.createElement('li');
          item.textContent = `${label ? label.textContent.trim() : section.dataset.requiredLabel}: ${field.validationMessage}`;
          errorList.appendChild(item);
        });
        errorSummary.hidden = false;
        errorSummary.focus();
        invalidFields[0].focus();
        return;
      }
      updateSubject();
      submissionDate.value = new Date().toISOString();
      submit.disabled = true;
      submit.textContent = submit.dataset.submittingLabel;
      status.textContent = submit.dataset.submittingLabel;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-wees-cookie-preferences]');

    if (!control) {
      return;
    }

    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wees-business-account-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hub = document.querySelector('[data-business-hub]');
    if (!hub || hub.dataset.initialized === 'true') return;
    hub.dataset.initialized = 'true';
    const deliveryResult = hub.querySelector('[data-delivery-result]');
    const deliveryZip = hub.querySelector('[data-delivery-zip]');
    const deliveryDistance = hub.querySelector('[data-delivery-distance]');
    const deliveryQualification = hub.querySelector('[data-delivery-qualification]');
    const form = hub.querySelector('#BusinessAccountRequest');
    if (!form) return;
    const successPanel = form.querySelector('[data-success-panel]');
    if (successPanel) {
      successPanel.focus();
      return;
    }
    const taxSelect = form.querySelector('[data-tax-select]');
    const taxPanel = form.querySelector('[data-tax-panel]');
    const taxFields = Array.from(taxPanel.querySelectorAll('input'));
    const taxRequired = Array.from(taxPanel.querySelectorAll('[data-tax-required]'));
    const ein = form.querySelector('[data-ein]');
    const noEin = form.querySelector('[data-no-ein]');
    const businessName = form.querySelector('[data-business-name]');
    const subject = form.querySelector('[data-request-subject]');
    const executiveReport = form.querySelector('[data-executive-report]');
    const errorSummary = form.querySelector('[data-form-error]');
    const errorList = form.querySelector('[data-error-list]');
    const submit = form.querySelector('[data-submit]');
    const submitStatus = form.querySelector('[data-submit-status]');
    const updateTaxFields = () => {
      const requested = taxSelect.value === 'Yes';
      taxPanel.hidden = !requested;
      taxFields.forEach((field) => { field.disabled = !requested; });
      taxRequired.forEach((field) => { field.required = requested; });
    };
    const updateEin = () => {
      if (noEin.checked) ein.value = '';
      ein.disabled = noEin.checked;
    };
    const updateSubject = () => {
      const name = businessName.value.trim();
      subject.value = name ? `New Wees Express Business Account Request — ${name}` : 'New Wees Express Business Account Request';
    };
    taxSelect.addEventListener('change', updateTaxFields);
    noEin.addEventListener('change', updateEin);
    businessName.addEventListener('input', updateSubject);
    form.addEventListener('input', (event) => event.target.removeAttribute('aria-invalid'));
    updateTaxFields();
    updateEin();
    updateSubject();
    const fieldValue = (selector) => form.querySelector(selector)?.value.trim() || '';
    const selectedProducts = () => Array.from(form.querySelectorAll('.wba-choices input:checked')).map((field) => field.nextElementSibling.textContent.trim());
    const reportSection = (title, rows) => {
      const populated = rows.filter((row) => row[1]);
      if (!populated.length) return '';
      return `${title}\n${'-'.repeat(title.length)}\n${populated.map((row) => `${row[0]}: ${row[1]}`).join('\n')}`;
    };
    const buildExecutiveReport = () => {
      const easternDate = new Intl.DateTimeFormat('en-US', {timeZone:'America/Detroit',dateStyle:'long',timeStyle:'short'}).format(new Date());
      const products = selectedProducts();
      const sections = [
        '================================================\nBUSINESS ACCOUNT REQUEST\n================================================',
        reportSection('Submission Summary', [['Submitted', easternDate],['Source', fieldValue('input[name="contact[Submission source]"]')],['Preliminary delivery result', deliveryResult?.value || 'Not checked'],['ZIP code', deliveryZip?.value],['Approximate ZIP-centroid distance', deliveryDistance?.value],['Qualification', deliveryQualification?.value]]),
        reportSection('Business Information', [['Legal business name', fieldValue('#wba-legal-name')],['DBA name', fieldValue('#wba-dba')],['Business type', fieldValue('#wba-business-type')],['Industry or operation type', fieldValue('#wba-industry')],['Business website', fieldValue('#wba-website')],['Number of locations', fieldValue('#wba-locations')]]),
        reportSection('Primary Contact', [['Name', `${fieldValue('#wba-first')} ${fieldValue('#wba-last')}`.trim()],['Job title or role', fieldValue('#wba-role')],['Business email', fieldValue('#wba-email')],['Business phone', fieldValue('#wba-phone')],['Preferred contact method', fieldValue('#wba-contact-method')]]),
        reportSection('Business Address', [['Street address', fieldValue('#wba-street')],['Address line 2', fieldValue('#wba-address-2')],['City', fieldValue('#wba-city')],['State', fieldValue('#wba-state')],['ZIP or postal code', fieldValue('#wba-zip')],['Country', fieldValue('#wba-country')]]),
        reportSection('Requested Services', [['Services', fieldValue('#wba-path')]]),
        products.length ? `Products of Interest\n--------------------\n${products.map((product) => `• ${product}`).join('\n')}` : '',
        reportSection('Purchasing Profile', [['Estimated purchasing frequency', fieldValue('#wba-frequency')],['Estimated monthly supply-spend range', fieldValue('#wba-spend')],['Multi-location details', fieldValue('#wba-multi-location')]]),
        reportSection('Tax Status', [['EIN status', noEin.checked ? 'I do not have an EIN' : (fieldValue('#wba-ein') ? 'EIN provided' : 'Not provided')],['Tax-exempt request', fieldValue('#wba-tax-request')],['State of exemption', fieldValue('#wba-exemption-state')],['Type of exemption', fieldValue('#wba-exemption-type')],['Certificate or exemption number', fieldValue('#wba-certificate-number')],['Expiration date', fieldValue('#wba-expiration')],['Authorized purchaser name', fieldValue('#wba-authorized-purchaser')]]),
        reportSection('Additional Notes', [['Additional business notes', fieldValue('#wba-challenges')]])
      ].filter(Boolean);
      executiveReport.value = sections.join('\n\n');
    };
    form.addEventListener('submit', (event) => {
      const invalidFields = Array.from(form.querySelectorAll('input:invalid, select:invalid, textarea:invalid')).filter((field) => !field.disabled);
      if (invalidFields.length) {
        event.preventDefault();
        errorList.innerHTML = '';
        invalidFields.forEach((field) => {
          field.setAttribute('aria-invalid', 'true');
          const label = field.id ? form.querySelector(`label[for="${field.id}"]`) : null;
          const item = document.createElement('li');
          item.textContent = `${label ? label.textContent.trim() : 'Required field'}: ${field.validationMessage}`;
          errorList.appendChild(item);
        });
        errorSummary.hidden = false;
        errorSummary.focus();
        invalidFields[0].focus();
        return;
      }
      updateSubject();
      buildExecutiveReport();
      Array.from(form.querySelectorAll('[name^="contact["]')).forEach((field) => {
        if (field === executiveReport || field === subject || field.id === 'wba-email') return;
        field.removeAttribute('name');
      });
      submit.disabled = true;
      submit.textContent = submit.dataset.submittingLabel;
      submitStatus.textContent = submit.dataset.submittingLabel;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wees-business-ordering"] && !Shopify.designMode) return;
  try {
    
(() => {
  function start(root) {
    if (root.dataset.ready) return;
    root.querySelectorAll('[data-guide]').forEach(group => {
      const panels = [...group.querySelectorAll('[data-guide-panel]')];
      const buttons = [...group.querySelectorAll('[data-choice]')];
      const select = group.querySelector('[data-guide-select]');
      const controls = group.querySelector('[data-guide-controls]');
      const status = group.querySelector('[data-guide-status]');
      if (!panels.length || !controls || !status) return;
      function show(value, announce) {
        const panel = panels.find(p => p.dataset.guidePanel === value);
        if (!panel) return;
        panels.forEach(p => { p.hidden = p !== panel; });
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.choice === value)));
        if (select) select.value = value;
        const extra = buttons.find(b => b.dataset.choice === value && b.closest('.wbo-more'));
        const moreLabel = group.querySelector('[data-more-selected]');
        if (moreLabel) moreLabel.textContent = extra ? ' · ' + select.selectedOptions[0].textContent : '';
        if (announce) status.textContent = panel.querySelector('h3').textContent;
      }
      buttons.forEach(b => b.addEventListener('click', () => show(b.dataset.choice, true)));
      if (select) select.addEventListener('change', () => show(select.value, true));
      show(select ? select.value : '0', false);
      controls.hidden = false;
    });
    root.dataset.ready = 'true';
  }
  document.querySelectorAll('[data-business-ordering]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-business-ordering]').forEach(start));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wees-nationwide-shipping"]) return;
  try {
    
(() => {
  function start(root) {
    if (root.dataset.initialized) return;
    const records = new Map([...root.querySelectorAll('[data-ns-record]')].map(el => [el.dataset.nsRecord, {code: el.dataset.nsRecord, name: el.dataset.name, description: el.dataset.description, note: el.dataset.note}]));
    const map = root.querySelector('[data-ns-map]'), paths = [...map.querySelectorAll('[data-ns-state]')];
    const labels = JSON.parse(root.querySelector('[data-ns-labels]').textContent);
    const panel = root.querySelector('[data-ns-panel]'), search = root.querySelector('#wns-search'), results = root.querySelector('[data-ns-results]'), help = root.querySelector('[data-ns-help]');
    const pathByCode = new Map(paths.map(p => [p.dataset.nsState,p]));
    if (records.size !== 51 || paths.length !== 51 || paths.some(p => !records.has(p.dataset.nsState))) return;
    let selected = null;
    const touch = matchMedia('(max-width: 700px), (hover: none) and (pointer: coarse)');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const guidance = () => {help.textContent = touch.matches ? help.dataset.touch : help.dataset.desktop;};
    function show(code) {
      const r=records.get(code);
      panel.classList.toggle('is-michigan',code==='MI');
      panel.querySelector('[data-ns-status]').textContent = r ? (code==='MI'?labels.mi_status:labels.status) : labels.eyebrow;
      panel.querySelector('[data-ns-name]').textContent = r ? r.name : labels.ready;
      panel.querySelector('[data-ns-description]').textContent = r ? r.description : labels.ready_copy;
      const note=panel.querySelector('[data-ns-note]');note.textContent=r?.note||'';note.hidden=!r?.note;
    }
    function select(code, scroll=false) {
      selected=code;
      paths.forEach(p=>{p.setAttribute('aria-pressed',String(p.dataset.nsState===code));p.classList.remove('is-hover');});
      show(code);
      if(scroll) panel.scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'nearest'});
    }
    paths.forEach((p,i)=>{
      const r=records.get(p.dataset.nsState);
      p.setAttribute('role','button');p.setAttribute('tabindex',i===0?'0':'-1');p.setAttribute('aria-pressed','false');
      p.setAttribute('aria-label',r.name+' — '+(r.code==='MI'?labels.mi_status:labels.status));
      p.addEventListener('click',()=>select(r.code));
      p.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&!selected){p.classList.add('is-hover');show(r.code);}});
      p.addEventListener('pointerleave',()=>{p.classList.remove('is-hover');if(!selected)show(null);});
      p.addEventListener('focus',()=>{if(!selected)show(r.code);});
      p.addEventListener('keydown',e=>{
        if(e.key==='Enter'||e.key===' '){e.preventDefault();select(r.code);}
        if(['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(e.key)){
          e.preventDefault();let index=e.key==='Home'?0:e.key==='End'?paths.length-1:(i+(['ArrowRight','ArrowDown'].includes(e.key)?1:-1)+paths.length)%paths.length;
          paths.forEach(n=>n.setAttribute('tabindex','-1'));paths[index].setAttribute('tabindex','0');paths[index].focus();
        }
      });
    });
    map.addEventListener('click',e=>{if(e.target===map)select(null);});
    root.querySelector('[data-ns-clear]').addEventListener('click',()=>{select(null);search.value='';results.replaceChildren();});
    function finder(){
      const q=search.value.trim().toLowerCase();results.replaceChildren();if(!q)return;
      const exact=records.get(q.toUpperCase());
      const found=exact?[exact]:[...records.values()].filter(r=>r.name.toLowerCase().includes(q));
      if(!found.length){const p=document.createElement('p');p.textContent=labels.search_empty;results.append(p);return;}
      found.forEach(r=>{const b=document.createElement('button');b.type='button';b.textContent=r.name+' · '+r.code;b.addEventListener('click',()=>{select(r.code);search.value=r.name;results.replaceChildren();});results.append(b);});
    }
    search.addEventListener('input',finder);
    search.addEventListener('keydown',e=>{if(e.key==='ArrowDown'&&results.firstElementChild?.tagName==='BUTTON'){e.preventDefault();results.firstElementChild.focus();}if(e.key==='Enter'&&results.querySelectorAll('button').length===1){e.preventDefault();results.querySelector('button').click();}});
    root.querySelectorAll('[data-ns-pick]').forEach(el=>{const r=records.get(el.dataset.nsPick);el.setAttribute('aria-label',r.name+' — '+(r.code==='MI'?labels.mi_status:labels.status));el.addEventListener('click',e=>{e.preventDefault();select(r.code);search.value=r.name;results.replaceChildren();root.querySelector('#shipping-explorer').scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'start'});search.focus({preventScroll:true});});});
    root.addEventListener('keydown',e=>{if(['Tab','Enter',' ','Escape','ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].includes(e.key))help.textContent=help.dataset.desktop;if(e.key==='Escape'){select(null);results.replaceChildren();}});
    root.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')help.textContent=help.dataset.touch;});
    touch.addEventListener('change',guidance);guidance();
    root.querySelector('[data-ns-enhance]').hidden=false;root.querySelector('[data-ns-fallback]').hidden=true;root.dataset.initialized='true';
  }
  document.querySelectorAll('[data-nationwide]').forEach(start);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-nationwide]').forEach(start));
})();


  } catch(e) { console.error(e); }
})();
})();
